import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { BlocoQuadra } from "../typings";

function useBlocoQuadra(tenantId: string | null, search?: string) {
  return useQuery(
    [`/v1/tenants/${tenantId}/bloco-quadra`, tenantId],
    async () => {
      const { data } = await axios.get<PaginateResult<BlocoQuadra>>(
        `/v1/tenants/${tenantId}/bloco-quadra`,
        {
          params: {
            search,
          },
        }
      );

      return data;
    },
    {
      enabled: !!tenantId,
    }
  );
}

export default useBlocoQuadra;
